import {
	faGlobe as farGlobe,
	faMobile as farMobile,
	faMoneyBill as farMoneyBill,
} from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faCalculator as fasCalculator } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import { Config } from "@/app/config";
import { RetailAccountSmallCalculator } from "@/component/RetailAccount/SmallCalculator/RetailAccountSmallCalculator";
import imgObaLogo from "@/img/cibeco/oba-logo.png";
import cibEcoBadge from "@/img/landing/bankszamla/cib/cib_eco_badge.svg";
import { GoogleAnalytics4 } from "@/shared/lib/google-analytics-4";
import {
	BmBadge,
	ButtonLegacy,
	IconBox,
	IconBoxGrid,
	LandingContainer,
	List,
	ListUi3,
	ListUi3Item,
	Stack,
	Typography,
} from "@/shared/ui";
import { formatText } from "@/shared/ui/format";
import { faBankmonitor } from "@/shared/ui/fortawesome/bankmonitor";
import { LandingBottom } from "@/shared/ui/landing/LandingBottom";
import { LandingHeader } from "@/shared/ui/landing/LandingHeader";
import { LandingHeaderLayout } from "@/shared/ui/landing/LandingHeaderLayout";

/**
 * @Routing
 *
 * @title "Ingyenes Bankszámla 2 évig | CIB ECO"
 * @description "Ellenőrizd a Bankmonitor bankszámla kalkulátorral, hogy a 2 évig ingyenes CIB ECO bankszámlánál van-e jobb a számodra! Spórolj évi több tízezer Ft-ot!"
 * @route "/bankszamla/ingyenes-bankszamla-online/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<>
				<LandingHeader theme="retail">
					<LandingHeaderLayout template="small-calculator">
						<Stack
							gap={{
								xs: 4,
								lg: 5,
							}}
							alignItems={"start"}
						>
							<div>
								<Typography as="h1" variant="title-1" gutterBottom>
									2 évig <br /> ingyenes bankszámla <br /> 30 000 Ft jutalommal
								</Typography>
								<Typography as="h1" variant="subtitle-1">
									CIB ECO bankszámla - a számlanyitástól számított 2 évig az alábbi díjfeltételek
									ingyenesek:
								</Typography>
							</div>
							<BmBadge prepend={<FontAwesomeIcon icon={faBankmonitor} />}>
								Kizárólag a bankmonitornál!
							</BmBadge>

							<ListUi3 gutterSize="sm">
								<ListUi3Item>
									<span className="text-primary">0 Ft</span> számlavezetési díj
								</ListUi3Item>
								<ListUi3Item>
									<span className="text-primary">0 Ft</span> tranzakciós illeték
								</ListUi3Item>
								<ListUi3Item>
									<span className="text-primary">0 Ft</span> átutalási díj
								</ListUi3Item>
								<ListUi3Item>
									<span className="text-primary">0 Ft</span> éves kártyadíj
								</ListUi3Item>
								<ListUi3Item>
									<span className="text-primary">8% éves kamat, max 6 hónapos lekötésre</span>, max
									30 naptári napon belül nyitott számlák esetében *
								</ListUi3Item>
							</ListUi3>

							<IconBoxGrid>
								<IconBox icon={<FontAwesomeIcon icon={farMoneyBill} />} direction={{ lg: "vertical" }}>
									Legalább minimálbér jóváírás
								</IconBox>
								<IconBox icon={<FontAwesomeIcon icon={farMobile} />} direction={{ lg: "vertical" }}>
									Mobil app ügyintézés
								</IconBox>
								<IconBox icon={<FontAwesomeIcon icon={farGlobe} />} direction={{ lg: "vertical" }}>
									Online számlanyitás
								</IconBox>
							</IconBoxGrid>
						</Stack>
						<div id="cib-eco-kalkulator">
							<RetailAccountSmallCalculator variant="cib-eco-lead" />
						</div>
					</LandingHeaderLayout>
				</LandingHeader>
				<LandingContainer bgClassName="bg-light" size="lg">
					<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-secondary text-center" id="megtakaritas">
						Ennyit spórolhatsz
					</h2>
					<p className="text-center">
						Nézd meg, hogy mennyit nyerhetsz, ha nem a bankfiókban, hanem a
						<strong> Bankmonitoron keresztül igényelsz CIB ECO bankszámlát!</strong>
					</p>
					<Table striped bordered responsive hover className="table-sm">
						<thead>
							<tr>
								<th scope="col" className="bg-secondary" aria-label="Költség" />
								<th scope="col" className="bg-secondary text-white">
									Számlanyitás Bankmonitorral
								</th>
								<th scope="col" className="bg-secondary text-white">
									Számlanyitás közvetlenül a CIB-nél
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th scope="row" className="small font-weight-bold">
									Számlavezetési díj
								</th>
								<td className="text-success font-weight-bold">0 Ft</td>
								<td> 0 Ft</td>
							</tr>
							<tr>
								<th scope="row" className="small font-weight-bold">
									Bankkártya költsége
								</th>
								<td className="text-success font-weight-bold">2 évig 0 Ft</td>
								<td>1 évig 0 Ft, utána 6 522 Ft/év</td>
							</tr>
							<tr>
								<th scope="row" className="small font-weight-bold">
									Átutalás költsége netbankon
								</th>
								<td className="text-success font-weight-bold">2 évig 0 Ft</td>
								<td>0,663% max. 25 364 Ft</td>
							</tr>
							<tr>
								<th scope="row" className="small font-weight-bold">
									Állandó átvezetési megbízás
									<br /> teljesítése bankon belül
								</th>
								<td className="text-success font-weight-bold">2 évig 0 Ft</td>
								<td>0,639%, max. 24 896 Ft</td>
							</tr>
							<tr>
								<th scope="row" className="small font-weight-bold">
									Állandó átutalási költség
									<br /> netbankon
								</th>
								<td className="text-success font-weight-bold">2 évig 0 Ft</td>
								<td>0,639%, max. 24 896 Ft</td>
							</tr>
							<tr>
								<th scope="row" className="small font-weight-bold">
									Csoportos beszedési költség
									<br /> netbankon
								</th>
								<td className="text-success font-weight-bold">2 évig 0 Ft</td>
								<td>0,639%, max. 24 896 Ft</td>
							</tr>

							<tr>
								<th scope="row" className="small font-weight-bold">
									Készpénzfelvétel ATM-ből
									<br />
									<span className="small">
										- jogszabályi, havonta két ingyenes készpénzfelvétel lehetősége összesen max.
									</span>
								</th>
								<td className="text-success font-weight-bold">
									300 ezer forint értékben <br /> vagy havonta egy alkalommal <br />
									akár 400 ezer forint értékben CIB ATM-ből.
								</td>
								<td>
									300 ezer forint értékben,
									<br /> egyéb esetben 1 864 Ft
								</td>
							</tr>
							<tr>
								<th scope="row" className="small font-weight-bold">
									Készpénzfelvétel bankfiókban
								</th>
								<td colSpan={2} className="text-center">
									3,013%, min. 2170 max. 217 545 Ft
								</td>
							</tr>
							<tr>
								<th scope="row" className="small font-weight-bold">
									0-24 órás videós online számlanyitás
								</th>
								<td>van</td>
								<td>van</td>
							</tr>
							<tr>
								<th scope="row" className="small font-weight-bold">
									Biztonsági értesítés a tranzakciókról
									<br /> mobil applikáción keresztül
								</th>
								<td>van</td>
								<td>van</td>
							</tr>
						</tbody>
					</Table>
				</LandingContainer>
				<LandingContainer>
					<Row className="align-items-center justify-content-center">
						<Col lg={6} className="mb-lg-0 mb-4">
							<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-secondary" id="garancia">
								CIB ECO ingyenes bankszámla nyitás feltételei
							</h2>
							<List itemStyle="tick" variant="secondary">
								<List.Item>
									<strong>Bankmonitoron</strong> keresztüli igénylés
								</List.Item>
								<List.Item>
									<strong>Online</strong> számlanyitás
								</List.Item>
								<List.Item>
									Havonta <strong>beérkezik a számládra</strong> a minimálbérnek megfelelő összeg
									(jelenleg {formatText(Config.getMinWage(), "ft")})
								</List.Item>
								<List.Item>
									<strong>Nem rendelkezel</strong> CIB számlával
								</List.Item>
							</List>
							<List itemStyle="tick" variant="secondary" className="mt-5">
								<List.Item>
									A fenti díjtételekre vonatkozó ingyenesség egyéb feltételei, amelyeket a CIB Bank
									Zrt. szabályzatai tartalmaznak (a CIB ECO, CIB ECO Plusz bankszámlákra vonatkozó
									Kondíciós listák, a fogyasztók és egyéni vállalkozók részére szóló Bankszámlákra és
									a fizetési műveletekre vonatkozó Különös Üzletszabályzat, Általános Lakossági
									Üzletszabályzat, a Bankmonitoron keresztül történő számlanyitásra vonatkozó
									Promóciós Szabályzat)**
								</List.Item>
							</List>
						</Col>
						<Col lg={6} md={8}>
							<img src={cibEcoBadge} className="p-4" alt="CIB ECO" loading="lazy" />
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer className="text-center" size="lg" bgClassName="bg-light">
					<div className="h3 text-secondary w-75 text-uppercase mx-auto mb-4">
						<strong>Bankszámla nyitás egyszerűen!</strong>
						<br />
						<span className="font-weight-light">
							Kalkulálj és nézd meg, hogy a 2 évig ingyenes CIB ECO bankszámlánál számodra van-e jobb! Add
							le az érdeklődésedet és indítsd el az online szerződéskötés folyamatát!
						</span>
					</div>
					<ButtonLegacy
						href="#cib-eco-kalkulator"
						variant="secondary"
						icon={<FontAwesomeIcon icon={fasCalculator} />}
						onClick={() =>
							GoogleAnalytics4.sendEvent("BM_scrollTo", {
								buttonName: "faqToCalculator",
							})
						}
					>
						Irány a kalkulátorra
					</ButtonLegacy>
				</LandingContainer>
				<LandingContainer className="text-center" size="sm">
					<img src={imgObaLogo} alt="OBA" width="44" height="100" loading="lazy" />
				</LandingContainer>
				<LandingContainer size="sm">
					<p className="small mb-0">*A Bank a betéti szerződésben rögzíti a betét lekötési feltételeket.</p>
					<p className="small mb-0 mt-5">
						**A tájékoztatás nem teljes körű, a bankszámlára vonatkozó részletes feltételeket a Fogyasztók
						részére szóló CIB ECO bankszámla kondíciós lista, a fogyasztók és egyéni vállalkozók részére
						szóló Bankszámlákra és a fizetési műveletekre vonatkozó Különös Üzletszabályzat, valamint az
						Általános Lakossági Üzletszabályzat tartalmazza, melyek megtalálhatóak a www.cib.hu honlapon,
						valamint a CIB bankfiókokban. A további feltételeket a CIB Bank Zrt. lakossági ügyfelek részére
						szóló Bankmonitoron keresztül történő számlanyitásra vonatkozó Promóciós Szabályzata, valamint a
						CIB ECO, CIB ECO Plusz bankszámlákra vonatkozó Kondíciós listák tartalmazzák.
					</p>
				</LandingContainer>
				<LandingBottom tags="bankszamla" />
			</>
		);
	}
}
